import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Company information",
    paras: [
      "This website is operated by Fox Project Management Consultancy Ltd.",
      "Registered office: Westgate House, Seedhill, Paisley, PA1 1JE. Registered in Scotland, company number SC900643. Contact: info@foxconsultancy.org.",
    ],
  },
  {
    title: "Use of this website",
    paras: [
      "The content of this website is provided for general information purposes only. It does not constitute professional, contractual or technical advice, and you should not rely on it as a substitute for advice tailored to your specific project. Please contact us directly to discuss your requirements.",
    ],
  },
  {
    title: "Intellectual property",
    paras: [
      "The design and content of this website — including the Fox name and fox device — are the property of Fox Project Management Consultancy Ltd and may not be reproduced without permission.",
      "Client names, logos and project imagery shown on this site remain the property of their respective owners and are reproduced solely to illustrate work we have been involved in.",
    ],
  },
  {
    title: "Accuracy of information",
    paras: [
      "We use reasonable endeavours to keep the information on this website accurate and up to date, but we make no warranties or representations of any kind. Content may be changed or withdrawn at any time without notice.",
    ],
  },
  {
    title: "External links",
    paras: [
      "Where this website links to third-party websites, those links are provided for convenience only. We have no control over, and accept no responsibility for, the content of external sites.",
    ],
  },
  {
    title: "Liability",
    paras: [
      "Nothing on this page excludes or limits our liability for anything that cannot be excluded or limited by law. Subject to that, we exclude all liability arising from use of, or reliance on, this website to the fullest extent permitted by law.",
    ],
  },
  {
    title: "Governing law",
    paras: [
      "This website and these terms are governed by the laws of Scotland, and the courts of Scotland shall have exclusive jurisdiction over any dispute arising from them.",
    ],
  },
];

export default function Legal() {
  return (
    <>
      <PageHeader
        overline="Legal"
        lines={["Legal notice", "& terms of use"]}
        intro="The legal terms governing the use of this website, and the registered details of Fox Project Management Consultancy Ltd."
        testid="legal-headline"
      />
      <section className="max-w-4xl mx-auto px-6 py-20 sm:py-28" data-testid="legal-content">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.04}>
            <div className="grid sm:grid-cols-12 gap-4 py-8 border-t border-zinc-800/60 last:border-b">
              <span className="sm:col-span-2 font-mono text-xs text-zinc-600 tracking-[0.2em] pt-1">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="sm:col-span-10">
                <h2 className="font-display text-lg font-bold text-zinc-100">{s.title}</h2>
                {s.paras.map((p) => (
                  <p key={p.slice(0, 32)} className="mt-3 text-sm text-zinc-400 font-light leading-relaxed">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </>
  );
}
